// An HTTP success without the expected job identity/status is not an editor receipt.
export function validJobEditorReceipt(response, expectedId = null) {
  const job=response?.data?.data;
  return Boolean(response?.success && /^\d+$/.test(String(job?.job_id || ''))
    && ['draft','published','validating','hidden'].includes(job?.job_status)
    && ([null,undefined,''].includes(expectedId) || String(job.job_id)===String(expectedId)));
}
